import React from 'react';
import GrafanaDashboard from "@/components/GrafanaDashboard/GrafanaDashboard";

function page() {
    return (<GrafanaDashboard/>);
}

export default page
